import styled from '@emotion/styled';
import COLORS3 from '@zola/zola-ui/src/styles/emotion/colors3';
import FONTS from '@zola/zola-ui/src/styles/emotion/fonts';
import MEDIA_QUERY from '@zola/zola-ui/src/styles/emotion/mediaQuery';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import { concealScrollbars } from '@zola/zola-ui/src/styles/emotion/utils';
import { HEADER_PADDING_DESKTOP, HEADER_PADDING_MOBILE } from '../CardListing.styles';

export const BubblesRow = styled.div`
  display: flex;
  gap: ${SPACING.S16};
  flex-wrap: nowrap;
  justify-content: center;
  margin: 0;

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    justify-content: initial;
    margin: 0 -${HEADER_PADDING_DESKTOP} ${SPACING.S16};
    padding: 0 ${HEADER_PADDING_DESKTOP};
    overflow-x: auto;
    ${concealScrollbars}
  }

  ${MEDIA_QUERY.MOBILE} {
    margin: 0 -${HEADER_PADDING_MOBILE} ${SPACING.S8};
    padding: 0 ${HEADER_PADDING_MOBILE};
  }
`;

export const BubbleImage = styled.span`
  display: block;
  aspect-ratio: 1;
  background-color: ${COLORS3.BLACK_005};
  background-position: center;
  background-size: cover;
  border-radius: 12px;
  width: 100px;

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    width: 90px;
  }
`;

export const BubbleLabel = styled.span`
  ${FONTS.textSizeUltraCompact(FONTS.SIZE.SMALLER)};
  font-weight: ${FONTS.WEIGHT.SEMI_BOLD};
`;

export const BubbleWrapper = styled.a`
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${SPACING.S16};
  cursor: pointer;
  text-decoration: none;

  ${MEDIA_QUERY.DESKTOP} {
    &:hover {
      ${BubbleImage} {
        scale: 1.05;
      }
    }
  }
`;
